/**
 * Convert a base64 data URL (e.g. "data:image/png;base64,....") to a Blob, so it
 * can be uploaded as real binary through the backend document-upload proxy
 * instead of sending base64-encoded bytes with ContentEncoding: base64.
 *
 * @param {string} dataUrl - a data URL string
 * @returns {Blob}
 */
export const dataUrlToBlob = (dataUrl) => {
  const [header, base64] = dataUrl.split(",");
  const match = /data:(.*?);base64/.exec(header);
  const contentType = match ? match[1] : "application/octet-stream";

  const byteString = atob(base64);
  const bytes = new Uint8Array(byteString.length);
  for (let i = 0; i < byteString.length; i++) {
    bytes[i] = byteString.charCodeAt(i);
  }
  return new Blob([bytes], { type: contentType });
};
